export function LogoIcon({
  className,
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox='0 0 147 14'
      className={className}
      {...props}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8.58603 4.46603C8.51687 4.51321 7.93798 4.06498 7.81503 3.9942C6.88266 3.46209 5.54813 2.96668 4.47744 3.24191C3.47591 3.49879 3.16853 4.6233 4.17263 5.1292C6.20899 6.1541 10.1818 5.73208 10.4149 9.05318C10.8043 14.584 2.70747 14.293 0 11.3599L1.62909 9.28385C2.03124 9.49617 2.39241 9.82382 2.79968 10.0545C3.82427 10.6364 5.6634 11.1659 6.76739 10.6102C7.34884 10.3166 7.62036 9.55908 7.0927 9.08202C6.56503 8.60495 4.60551 8.30351 3.82683 8.07022C1.7751 7.45685 0.220286 6.47127 0.543031 3.98634C1.10655 -0.33345 7.60499 -0.139479 10.0538 2.2773L8.58603 4.46603Z'
        fill='currentcolor'
      />
      <path
        d='M19.29 0.602125C24.3693 0.16438 28.4037 5.56412 25.5732 10.2378C23.1962 14.1591 17.7249 14.5261 14.8458 10.9717C11.5646 6.92454 14.3694 1.02676 19.29 0.602125ZM19.6947 3.39898C18.1424 3.52218 16.8412 4.82755 16.5799 6.3767C15.9882 9.85769 20.189 12.1696 22.5174 9.34131C24.4718 6.9691 22.7223 3.15783 19.6947 3.39898Z'
        fill='currentcolor'
      />
      <path
        d='M32.497 0.78418V10.4198H38.2988L38.373 10.4958V13.138L38.2988 13.2167H29.5078V0.78418H32.497Z'
        fill='currentcolor'
      />
      <path
        d='M44.3623 0.78418V10.4198H50.1614L50.2383 10.4958V13.138L50.1614 13.2167H41.373V0.78418H44.3623Z'
        fill='currentcolor'
      />
      <path
        d='M56.33 0.78418V13.138L56.2531 13.2167H53.3151L53.2383 13.138V0.78418H56.33Z'
        fill='currentcolor'
      />
      <path
        d='M63.8252 0.604719C65.8026 0.439582 67.8877 0.937616 69.4041 2.27969L67.8569 4.47104C66.8067 3.68205 64.9317 2.81442 63.6356 3.30983C63.0055 3.55098 62.6162 4.30852 63.1259 4.86422C63.6356 5.41992 65.8334 5.73971 66.6735 6.00184C68.8405 6.67287 70.2442 7.89961 69.6372 10.4317C68.7202 14.2613 63.1925 13.8577 60.5593 12.3059C60.3903 12.2063 59.3606 11.4881 59.3298 11.3832C59.2914 11.2548 60.8001 9.54836 60.9794 9.29935C61.7581 9.82884 62.5137 10.3505 63.4307 10.6126C64.2248 10.8406 66.3687 11.1395 66.6479 10.0176C66.8631 9.15256 66.2791 8.91402 65.608 8.69646C63.4102 7.97562 60.0317 7.9232 59.8344 4.80918C59.6782 2.37405 61.5967 0.790827 63.8252 0.604719Z'
        fill='currentcolor'
      />
      <path
        d='M74.2035 6.2348H81.3295V0.769531H82.6486L82.7562 0.877002V13.2309H81.3295V7.61881H74.2035V13.2309H72.7793V0.877002L72.8843 0.769531H74.0959L74.2035 0.877002V6.2348Z'
        fill='currentcolor'
      />
      <path
        d='M94.5222 0.769531V2.15354H87.2527V6.2348H93.8101V7.61881H87.2527V11.8469H94.5222V13.2309H85.7568V0.877002L85.8644 0.769531H94.5222Z'
        fill='currentcolor'
      />
      <path
        d='M109.706 13.2381H108.246L106.953 10.4806L100.403 10.4649L100.165 10.5855L98.9815 13.2381H97.5215L102.801 0.89214C102.837 0.810882 102.893 0.792534 102.972 0.776806C103.126 0.747973 104.294 0.761079 104.366 0.810882L109.709 13.2381H109.706ZM106.359 9.08349L103.615 2.59594L100.872 9.08349H106.359Z'
        fill='currentcolor'
      />
      <path
        d='M114.133 11.8469H120.655L120.762 11.9543V13.2309H112.709V0.769531H114.028L114.133 0.877002V11.8469Z'
        fill='currentcolor'
      />
      <path
        d='M133.312 0.769531V2.15354H129.249V13.2309H127.825V2.15354H123.763V0.877002L123.87 0.769531H133.312Z'
        fill='currentcolor'
      />
      <path
        d='M137.738 6.2348H144.864V0.769531H146.217V13.2309H144.864V7.61881H137.738V13.2309H136.312V0.769531H137.631L137.738 0.877002V6.2348Z'
        fill='currentcolor'
      />
    </svg>
  );
}
